// Shared formatting helpers and style constants for the classes feature

export { fmtDate, fmtDateTime, fmtTime, fmtTimeRange } from '@/core/lib/formatters'

export const LANGUAGE_BADGE: Record<string, { label: string; className: string }> = {
  en:  { label: '🇬🇧 EN',    className: 'bg-sky-50 text-sky-700 border border-sky-200' },
  es:  { label: '🇪🇸 ES',    className: 'bg-orange-50 text-orange-700 border border-orange-200' },
  any: { label: '🌐 EN/ES',  className: 'bg-violet-50 text-violet-700 border border-violet-200' },
}

export function languageBadge(lang: string | null | undefined) {
  return LANGUAGE_BADGE[(lang ?? 'any').toLowerCase()] ?? LANGUAGE_BADGE.any
}

export const STATUS_BADGE: Record<string, { label: string; className: string }> = {
  draft:    { label: 'Draft',          className: 'bg-gray-50 text-slate-500 border border-slate-150' },
  checking: { label: '📝 Check-in open', className: 'bg-amber-100 text-amber-800 border border-amber-200' },
  active:   { label: '🟢 In progress', className: 'bg-green-100 text-green-700 border border-green-200' },
  closed:   { label: 'Finished',       className: 'bg-navy text-white' },
}

export const inputClass =
  'w-full border border-slate-150 rounded-lg px-3 py-2 text-sm text-navy focus:outline-none focus:ring-2 focus:ring-primary bg-white'
